import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@hooks';
import { shouldShowDevData, toggleDevData } from '@store/dev/dev.slice';

export const DevDataSwitch = () => {
  const dispatch = useAppDispatch();
  const clickHandler = () => {
    dispatch(toggleDevData(null));
  };
  const showData = useAppSelector(shouldShowDevData);
  return (
    <FormGroup sx={{ ml: 2, mt: 1 }}>
      <FormControlLabel control={<Switch checked={showData} onClick={clickHandler} />} label='Show raw block data' />
    </FormGroup>
  );
};
